import { render, staticRenderFns } from "./LogoStyleGuide.vue?vue&type=template&id=7315e7d8"
import script from "./LogoStyleGuide.vue?vue&type=script&lang=js"
export * from "./LogoStyleGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports